import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* unitSetActive(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_UNIT_SET_ACTIVE_REQUEST
    });

    yield call(Http.put, `units/${action.payload?.unitId}/set-active`, {
      active: action.payload?.active,
      unitId: action.payload?.unitId
    });

    yield put({
      type: Constants.LOADING_HIDE
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_UNIT_SET_ACTIVE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUnitSetActive() {
  yield takeEvery(Constants.GLOBAL_UNIT_SET_ACTIVE_START, unitSetActive);
}
